<!-- customer-panel/src/views/Pages/Tables/detail/components/view/CreateViewForm.vue -->
<template>
    <div class="create-view-form">
        <a-form @submit.prevent="handleSubmit">
            <a-form-item label="View Name" :required="true">
                <a-input v-model="name" placeholder="Enter view name" />
            </a-form-item>
            <a-form-item label="Description">
                <a-input v-model="description" placeholder="Enter description" />
            </a-form-item>
            <div class="form-actions">
                <a-button @click="$emit('cancel')">Cancel</a-button>
                <a-button type="primary" htmlType="submit">Save</a-button>
            </div>
        </a-form>
    </div>
</template>

<script>
import { TABLE_API } from "../../../../../api/table";

export default {
    name: "CreateViewForm",
    props: {
        filters: {
            type: Array,
            default: () => [],
        },
        sort: {
            type: Object,
            default: () => ({}),
        },
        search: {
            type: String,
            default: "",
        },
        hiddenFields: {
            type: Array,
            default: () => [],
        },
        lockedFields: {
            type: Array,
            default: () => [],
        },
        tableId: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            name: "",
            description: "",
        };
    },
    methods: {
        async handleSubmit() {
            if (!this.name.trim()) {
                this.$message.error("View name is required.");
                return;
            }
            try {
                const newView = await TABLE_API.createView(
                    this.tableId,
                    this.name,
                    this.description,
                    this.filters,
                    this.sort,
                    null, // Cursor değeri isterseniz ekleyebilirsiniz.
                    this.search,
                    this.hiddenFields,
                    this.lockedFields
                );
                this.$emit("view-created", newView);
            } catch (error) {
                console.error("Görünüm oluşturulurken hata oluştu:", error);
                this.$message.error("Görünüm oluşturulurken bir hata oluştu.");
            }
        },
    },
};
</script>

<style scoped>
.create-view-form {
    .form-actions {
        display: flex;
        justify-content: flex-end;
        gap: 10px;
    }
}
</style>
